import Swiper from 'swiper';

function siteTopSwiper(){
  //TOPスライダー
  new Swiper('.top_slider', {
    loop: true,
    slidesPerView: 3,
    centeredSlides: true,
    autoplay: false,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    paginationClickable: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    },
    on: {
      init: function () {
        const swiper = document.querySelector('.top_slider');
        const wrapper = document.querySelector('.top_slider .swiper-wrapper');
        swiper.style.height = "";
        wrapper.style.height = "";
        const wrapperHeght = parseInt(wrapper.clientHeight);
        wrapper.style.height = (wrapperHeght + 50) + "px";
        swiper.style.height = (wrapperHeght + 50) + "px";
      },
    },
  });
  //document.querySelector('top_slider').computedStyleMap.height = "";

//口コミスライダー
new Swiper('.swiper__ranked-shop', {
  //Optional parameters
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

//エリアスライダー
new Swiper('.swiper__area-shop', {
  // Optional parameters
  loop: true,
  slidesPerView: 5,
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: false,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 5
    }
  },
});

//カテゴリスライダー
new Swiper('.swiper__category', {
  // Optional parameters
  loop: false,
  slidesPerView: 5,
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: false,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 5
    }
  },
});

//特集スライダー
new Swiper('.swiper__feature', {
  // Optional parameters
  loop: true,
  slidesPerView: 2.5,
  spaceBetween: 25,
  autoplay: true,
  preventClicks: true,
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 1.3,
      spaceBetween: 15
    }
  },
});

//おすすめショップスライダー
new Swiper('.swiper__recommend-shop', {
  // Optional parameters
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

//新着スライダー
new Swiper('.swiper__arrived-shop', {
  // Optional parameters
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: false,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});

//ランキングスライダー
new Swiper('.swiper__accessed-shop', {
  // Optional parameters
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 10,
  autoplay: false,
  preventClicks: true,
  centeredSlides: false,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});


}


// $('.swiper-slide').hover(
//   function () {
//     mySwiper.autoplay.stop();
//     return false;
//   },
//   function () {
//     mySwiper.autoplay.start();
//     return false;
//   }
// );

function resizeSlider() {
  let b = $('.swiper-slide');
  let aticleH = b.width();
  $('.top_slider').css('height', aticleH);
}

function resizeRecommendShop() {
  let $imgbox = $('section.recommend_shop .flexbox article .imgbox');
  let aticleH = $imgbox.width();
  $imgbox.css('height', aticleH);
}

$(function () {
  resizeSlider();
  resizeRecommendShop();
  siteTopSwiper();

  $(window).on('resize', function () {
    resizeSlider();
    resizeRecommendShop();
  });
});
